import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions, ResponseType, ResponseContentType } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { LocalStorageService } from 'ngx-webstorage';
import { environment } from '../../../../environments/environment';
import { SERVICES_URLS } from './services.urls';

@Injectable()
export class ResourcesService {
	private token: string = "";

	constructor(
		private http: Http,
		private _localStorage: LocalStorageService
	) {
		var token = _localStorage.retrieve('token');
		if (token != null)
			this.token = token;

		_localStorage.observe('token')
			.subscribe((token) => this.token = token);
	}

	public getToken(): string {
		return this.token;
	}

	private getBaseUrl(path: string): string {
		return environment.urlServer + SERVICES_URLS[path];
	}

	private getApiUrl(resource: string): string {
		var api_url = this.getBaseUrl('API') + SERVICES_URLS.SERVICES[resource];
		//console.log(api_url);
		return api_url;
	}

	public getPointAddress(query: string) {
		var headers = new Headers({ 'Content-Type': 'application/json' });
		var options = new RequestOptions({ headers: headers });
		return this.http.get(
			SERVICES_URLS.OPEN_MAP_URL +
			'?format=json&addressdetails=1&q=' + query.replace(',', '+').replace(' ', '+') +
			'&format=json&limit=1',
			options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public login(loginData: object) {
		var headers = new Headers({ 'Content-Type': 'application/json' });
		var options = new RequestOptions({ headers: headers });

		return this.http.post(this.getBaseUrl("AUTH"), loginData, options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getUserData() {
		var myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('Authorization', 'Token ' + this.token);
		var options = new RequestOptions({ headers: myHeaders });
		return this.http.get(this.getApiUrl('get_user_data'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getUsers() {
		var myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('Authorization', 'Token ' + this.token);
		var options = new RequestOptions({ headers: myHeaders });
		return this.http.get(this.getApiUrl('users'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public AddUsers(user) {
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });

		var options = new RequestOptions({ headers: headers });

		return this.http.post(this.getApiUrl("user_save"), user, options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public editUserPassword(id: number, user) {
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });

		var options = new RequestOptions({ headers: headers });

		return this.http.put(this.getApiUrl("user_save") + id + "/", user, options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public editUser(id: number, user) {
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });

		var options = new RequestOptions({ headers: headers });

		return this.http.put(this.getApiUrl("users") + id + "/", user, options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public deleteUser(id: number) {
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });

		var options = new RequestOptions({ headers: headers });

		return this.http.delete(this.getApiUrl("users") + id + "/", options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getPermissions() {
		var myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('Authorization', 'Token ' + this.token);
		var options = new RequestOptions({ headers: myHeaders });
		return this.http.get(this.getApiUrl('get_permissions'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getPersonal() {
		var myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('Authorization', 'Token ' + this.token);
		var options = new RequestOptions({ headers: myHeaders });
		return this.http.get(this.getApiUrl('personal'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}


	public getPbyPage(page: string) {
		var myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('Authorization', 'Token ' + this.token);
		var options = new RequestOptions(
			{
				headers: myHeaders,
				params: { "id_usuario": '0001', "grupo": 'TEST' }
			}
		);
		return this.http.get(this.getApiUrl('get_load_size'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getPersonalById(idPersonal: number) {
		var myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('Authorization', 'Token ' + this.token);
		var options = new RequestOptions(
			{
				headers: myHeaders,
				params: { "id_personal": idPersonal }
			}
		);
		return this.http.get(this.getApiUrl('get_personal_by_id'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public gePersonalID(idH: number) {
		var myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('Authorization', 'Token ' + this.token);
		var options = new RequestOptions({ headers: myHeaders });
		return this.http.get(this.getApiUrl('personal') + idH + "/", options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public addPersonal(personal) {
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });

		var options = new RequestOptions({ headers: headers });

		return this.http.post(this.getApiUrl("personal"), personal, options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public updatePersonal(id: number, personal) {
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });

		var options = new RequestOptions({ headers: headers });

		return this.http.put(this.getApiUrl("personal") + id + "/", personal, options)
			.map(this.extractData)
			.catch(this.handleError);
	}


	public deletePersonal(id: number) {
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });

		var options = new RequestOptions({ headers: headers });

		return this.http.delete(this.getApiUrl("personal") + id + "/", options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public ImportExcel(fileList, id_user) {
		var file: File = fileList[0];
		var formData: FormData = new FormData();
		formData.append('excel_file', file, file.name);
		var headers = new Headers();
		headers.append('Accept', 'application/json');
		headers.append('Authorization', 'Token ' + this.token);
		var options = new RequestOptions({
			headers: headers,
			params: { "id_usuario": id_user }
		});
		return this.http.post(environment.urlServer + 'import_data_excel/', formData, options)
			.map(this.extractData)
			.catch(this.handleError);
	}


	public ImportExcelRegistosHorarios(fileList, id_user) {
		var file: File = fileList[0];
		var formData: FormData = new FormData();
		formData.append('excel_file', file, file.name);
		var headers = new Headers();
		headers.append('Accept', 'application/json');
		headers.append('Authorization', 'Token ' + this.token);
		var options = new RequestOptions({
			headers: headers,
			params: { "id_usuario": id_user }
		});
		return this.http.post(environment.urlServer + 'import_rh_excel/', formData, options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public uploadFile(fileList, idPersonal, index, type) {
		var indexString = ""+index;
		var data = {
			'content': fileList,
			"id": idPersonal,
			"extension": "BMP",
			"type": type,
			"index": indexString
		}
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });
		var options = new RequestOptions({ headers: headers });
		return this.http.post(this.getApiUrl('upload_file'), data, options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public downloadFile(personalId,index,type) {
		var headers = new Headers();
		headers.append('Accept', 'application/json');
		var options = new RequestOptions({
			headers: headers,
			params: { "id": personalId, "type": type, "index": index , "extension": 'BMP'}
		});
		return this.http.get(this.getApiUrl('download_file'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public downloadRegistroHorarioRWNFile(codPersonal, startDateStr, endDateStr, noExport) {


		var parametros = {"codPersonal": codPersonal, "startDateStr": startDateStr, "endDateStr": endDateStr, "noExport": noExport}
		console.log(parametros);

		var headers = new Headers();
		headers.append('Accept', 'application/json');
		var options = new RequestOptions({
			headers: headers,
			params: { "codPersonal": codPersonal, "startDateStr": startDateStr, "endDateStr": endDateStr, "noExport": noExport},
		});

		console.log(options.params);

		return this.http.get(this.getApiUrl('download_registro_horario_rwn_file'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public downloadRegistroHorarioTableExcelFile(codPersonal, startDateStr, endDateStr, noExport) {
		var parametros = {"codPersonal": codPersonal, "startDateStr": startDateStr, "endDateStr": endDateStr, "noExport": noExport}
		console.log(parametros);

		var headers = new Headers();
		headers.append('Accept', 'application/json');
		var options = new RequestOptions({
			headers: headers,
			params: { "codPersonal": codPersonal, "startDateStr": startDateStr, "endDateStr": endDateStr, "noExport": noExport},
		});

		return this.http.get(this.getApiUrl('download_registro_horario_table_xls_file'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public downloadRegistroHorarioExcelFile(codPersonal, startDateStr, endDateStr, noExport) {


		var parametros = {"codPersonal": codPersonal, "startDateStr": startDateStr, "endDateStr": endDateStr, "noExport": noExport}
		console.log(parametros);

		var headers = new Headers();
		headers.append('Accept', 'application/json');
		var options = new RequestOptions({
			headers: headers,
			params: { "codPersonal": codPersonal, "startDateStr": startDateStr, "endDateStr": endDateStr, "noExport": noExport},
		});

		console.log(options.params);

		return this.http.get(this.getApiUrl('download_registro_horario_xls_file'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getEncargado() {
		var myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('Authorization', 'Token ' + this.token);
		var options = new RequestOptions({ headers: myHeaders });
		console.log(this.getApiUrl('get_cabecillas'))
		return this.http.get(this.getApiUrl('get_cabecillas'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getRegisterHours(supervisorCode?: any, startDate?: string, endDate?: string, noExport?: boolean) {
		var myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('Authorization', 'Token ' + this.token);
		let params: any = {};
		if (supervisorCode) {
			params["supervisor_code"] = supervisorCode;
		}
		if (startDate) {
			params["start_date"] = startDate;
		}
		if (endDate) {
			params["end_date"] = endDate;
		}
		if (noExport) {
			params["no_export"] = noExport;
		}
		var options = new RequestOptions({ headers: myHeaders, params: params });
		return this.http.get(this.getApiUrl('personal_registro_horario'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	// Historial de Registro de Horarios (change 2026-10-correcciones-campania-2, punto 5)
	public getHistorialRH(cabecillas: string[], desde?: string, hasta?: string) {
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });
		let params: any = {};
		if (cabecillas && cabecillas.length) {
			params["cabecilla"] = cabecillas;
		}
		if (desde) {
			params["desde"] = desde;
		}
		if (hasta) {
			params["hasta"] = hasta;
		}
		var options = new RequestOptions({ headers: headers, params: params });
		return this.http.get(this.getApiUrl('registro_horario_historial'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public addRegistroHorario(horario) {
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });

		var options = new RequestOptions({ headers: headers });

		return this.http.post(this.getApiUrl("registro_horario"), horario, options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getHorarioById(idH: number) {
		var myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('Authorization', 'Token ' + this.token);
		var options = new RequestOptions({ headers: myHeaders });
		return this.http.get(this.getApiUrl('registro_horario') + idH + "/", options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public updateHorario(id: number, hourR) {
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });

		var options = new RequestOptions({ headers: headers });

		return this.http.put(this.getApiUrl("registro_horario") + id + "/", hourR, options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public deleteHourRegister(id: number, motivo?: string) {
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });

		// Motivo opcional para el historial (change 2026-10-correcciones-campania-2, punto 5)
		var options = new RequestOptions({ headers: headers, params: motivo ? { motivo: motivo } : {} });

		return this.http.delete(this.getApiUrl("registro_horario") + id + "/", options)
			.map(this.extractData)
			.catch(this.handleError);
	}
	public changeExportState(horario) {
		var data = {
			"export": horario
		}
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });

		var options = new RequestOptions({ headers: headers });

		return this.http.post(this.getApiUrl("change_status"), data, options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getPersonalHR() {
		var myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('Authorization', 'Token ' + this.token);
		var options = new RequestOptions({ headers: myHeaders });
		return this.http.get(this.getApiUrl('get_personal_horario'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getPersonalHrAll(enPlanta=null) {
		var myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('Authorization', 'Token ' + this.token);
		var options = new RequestOptions({ headers: myHeaders });
		let url = this.getApiUrl('get_register_All')
  		if (enPlanta != null){
  			url += "?en_planta=" + enPlanta
  		}
	  		
 		return this.http.get(url, options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public gePersonaltHorario(codePersonal: string) {
		var myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('Authorization', 'Token ' + this.token);
		var options = new RequestOptions(
			{
				headers: myHeaders,
				params: { "codigo_personal": codePersonal }
			}
		);
		return this.http.get(this.getApiUrl('get_horario'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	private extractData(res: Response): object {
		let body = res.json();
		return body || {};
	}

	private handleError(error: Response | any) {
		let errMsg: string;
		if (error instanceof Response) {
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
		} else {
			errMsg = error.message ? error.message : error.toString();
		}
		console.error(errMsg);
		return Observable.throw(errMsg);
	}


	public getPlanillasControlLabores(supervisorCode?: string, startDate?: string, endDate?: string) {
		var myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('Authorization', 'Token ' + this.token);
		let params: any = {};
		if (supervisorCode) {
			params["supervisor_code"] = supervisorCode;
		}
		if (startDate) {
			params["start_date"] = startDate;
		}
		if (endDate) {
			params["end_date"] = endDate;
		}
		var options = new RequestOptions({ headers: myHeaders, params: params });
		return this.http.get(this.getApiUrl('labor_list'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getLaborById(laborId: number) {
		var myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');
		myHeaders.append('Authorization', 'Token ' + this.token);
		var options = new RequestOptions({ headers: myHeaders });
		return this.http.get(this.getApiUrl('labor') + laborId+ "/", options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public downloadPlanillasControlLaboresExcelFile(idUsuario, startDateStr, endDateStr) {

		var parametros = {"idUsuario": idUsuario, "startDateStr": startDateStr, "endDateStr": endDateStr}
		//console.log(parametros);
		var headers = new Headers();
		headers.append('Accept', 'application/json');
		var options = new RequestOptions({
			headers: headers,
			params: parametros,
		});
		console.log(options.params);
		return this.http.get(this.getApiUrl('download_labores_xls_file'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public downloadPlanillasControlLaborExcelFile(idLabor) {

		var parametros = {"idLabor": idLabor}
		var headers = new Headers();
		headers.append('Accept', 'application/json');
		var options = new RequestOptions({
			headers: headers,
			params: parametros,
		});
		console.log(options.params);
		return this.http.get(this.getApiUrl('download_labores_xls_file'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public downloadPlanillasControlLaborPDFFile(idLabor) {

		var parametros = {"idLabor": idLabor}
		var headers = new Headers();
		headers.append('Accept', 'application/json');
		var options = new RequestOptions({
			headers: headers,
			params: parametros,
		});
		console.log(options.params);
		return this.http.get(this.getApiUrl('download_labores_pdf_file'), options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public completeDay(dayInfo) {
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });
		var options = new RequestOptions({ headers: headers });
		return this.http.post(this.getApiUrl("complete_day"), dayInfo, options)
			.map(this.extractData)
			.catch(this.handleError);
	}

	// Jornadas pendientes: los errores salen como {status, error} para poder manejar el 401 y mostrar el mensaje.
	public getJornadasPendientes(fecha: string, area?: any) {
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });
		let params: any = { fecha: fecha };
		if (area) {
			params['area'] = area;
		}
		var options = new RequestOptions({ headers: headers, params: params });
		return this.http.get(this.getApiUrl('jornadas_pendientes'), options)
			.map(this.extractData)
			.catch(this.errorConEstado);
	}

	public cerrarJornadas(pedido) {
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });
		var options = new RequestOptions({ headers: headers });
		return this.http.post(this.getApiUrl('jornadas_pendientes_cerrar'), pedido, options)
			.map(this.extractData)
			.catch(this.errorConEstado);
	}

	// Fichajes sin persona (change 2026-10-fichajes-sin-persona): mismo manejo de errores que Jornadas pendientes.
	private paramsFechas(desde: string, hasta: string) {
		let params: any = {};
		if (desde) {
			params['desde'] = desde;
		}
		if (hasta) {
			params['hasta'] = hasta;
		}
		return params;
	}

	public getFichajesSinPersona(desde: string, hasta: string) {
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });
		var options = new RequestOptions({ headers: headers, params: this.paramsFechas(desde, hasta) });
		return this.http.get(this.getApiUrl('fichajes_sin_persona'), options)
			.map(this.extractData)
			.catch(this.errorConEstado);
	}

	public getFichajesSinPersonaExcel(desde: string, hasta: string) {
		var headers = new Headers({ 'Authorization': 'Token ' + this.token });
		var options = new RequestOptions({ headers: headers, params: this.paramsFechas(desde, hasta), responseType: ResponseContentType.Blob });
		return this.http.get(this.getApiUrl('fichajes_sin_persona_excel'), options)
			.map((res: Response) => res.blob())
			.catch(this.errorConEstado);
	}

	public getFichajesARevisar(desde: string, hasta: string) {
		var headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Token ' + this.token });
		var options = new RequestOptions({ headers: headers, params: this.paramsFechas(desde, hasta) });
		return this.http.get(this.getApiUrl('fichajes_a_revisar'), options)
			.map(this.extractData)
			.catch(this.errorConEstado);
	}

	public getFichajesARevisarExcel(desde: string, hasta: string) {
		var headers = new Headers({ 'Authorization': 'Token ' + this.token });
		var options = new RequestOptions({ headers: headers, params: this.paramsFechas(desde, hasta), responseType: ResponseContentType.Blob });
		return this.http.get(this.getApiUrl('fichajes_a_revisar_excel'), options)
			.map((res: Response) => res.blob())
			.catch(this.errorConEstado);
	}

	private errorConEstado(error: Response | any) {
		let mensaje = 'No se pudo completar la operación.';
		let estado = 0;
		if (error instanceof Response) {
			estado = error.status;
			try {
				const body = error.json() || {};
				mensaje = body.error || body.detail || mensaje;
			} catch (e) {}
		}
		return Observable.throw({ status: estado, error: mensaje });
	}

	public downloadS3MediaExportFile(flie_name: string){
		return this.http.get(environment.urlS3+'media/export/'+flie_name, null)
			.map(this.extractData)
			.catch(this.handleError);
	 }

}



// WEBPACK FOOTER //
// /app/src/app/theme/services/resources/resources.service.ts